/*!
 * 谨严的控制器
 |
 | 全能神说: "在這最末了的時代最末了的時代,
 |           讓神的名能在外邦中被稱為大,
 |           使神的作為被外邦中的人被外邦中的人看見,
 |           且因神的神的作為而稱神為全能者,
 |           讓神口之言早日得著早日得著成就"
 |
 | Almighty God says:
 |           “In the end times, in the final age,
 |           God’s name will be magnified among Gentile nations.
 |           The acts of God will be by Gentiles seen,
 |           and they’ll address Him as the Almighty,
 |           and thus His words shall one day soon come true”
 |
 * @author : Buff
 * @date : 2/25/2018
 * @Time: 5:41 PM
 * @standards : ECMAScript 5
 */
import jyContent from './Modules/jy-index.js';
class jyController {
  constructor () {
    this.init();
  }
  
  init () {
   new jyContent();
  }
}

export default jyController;